import * as utils from './utils';
import { storeData, getData, TrackedInfo } from './track';

async function init() {
  utils.initPostMessageListener();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const fromHovr: boolean = urlParams.get('fromHovr')?.toLocaleLowerCase() === 'true';
  const siteId: string | null = urlParams.get('siteId');
  const sessionID: string | null = urlParams.get('sessionId');
  const thirtyDayTrackingID: string | null = urlParams.get('thirtyDayTrackingId');

  if (fromHovr && siteId != null) {
    // pixel is being used inside of hovr
    // to track attribution engagement
    await storeData({
      sessionID,
      thirtyDayTrackingID,
      hovrEngaged: true,
      hovrEngagedDate: new Date().toISOString(),
      hovrFirstEngagedDate: new Date().toISOString(),
      siteId: siteId,
    }).catch((e) => {
      console.error('Error storing data:', e);
    });
  } else {
    const data: TrackedInfo = await getData();
    if (data.hovrEngagedDate == null) {
      data.hovrEngagedDate = new Date().toISOString();
    }

    window.parent.postMessage(
      data,
      utils.getTopWindowURL(),
    );
  }
}

init();
